import React from "react"
import { FaChevronRight } from "react-icons/fa"

function QuickAction({
  icon: Icon, label, onClick, danger = false
}) {
  return (
    <button className={danger ? "quick-action danger" : "quick-action"} onClick={onClick} type="button">
      <span className="quick-action-label">
        <Icon />
        {label}
      </span>
      <FaChevronRight />
    </button>
  )
}

export default QuickAction
